module.exports = require('./helpers/bundle-url').getBundleURL('2LpMj') + "download_dark.d189d7b6.png" + "?" + Date.now();